var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9706,
    cy: 16.9706,
    r: 12,
    transform: "rotate(-45 16.9706 16.9706)",
    fill: "#DB3643"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6687 16.9706L21.2143 14.425C21.6809 13.9583 21.6809 13.1946 21.2142 12.7279C20.7476 12.2612 19.9839 12.2612 19.5172 12.7279L16.9716 15.2735L14.426 12.7279C13.9593 12.2612 13.1957 12.2612 12.729 12.7279C12.2623 13.1946 12.2623 13.9583 12.729 14.425L15.2746 16.9706L12.729 19.5162C12.2623 19.9828 12.2623 20.7465 12.729 21.2132C13.1957 21.6799 13.9593 21.6799 14.426 21.2132L16.9716 18.6676L19.5172 21.2132C19.9839 21.6799 20.7476 21.6799 21.2142 21.2132C21.6809 20.7465 21.6809 19.9828 21.2143 19.5162L18.6687 16.9706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.3e98fefc288a621c98df235c80325623.svg";
export { ForwardRef as ReactComponent };